export default class UpdateUserInfoModel {
  nickName?: string;

  phoneNo?: string;

  phonePrefix?: string;

  remark?: string;

  accessGroup?: string;

  constructor() {
    this.phonePrefix = '86';
  }
}
